<template>
  <div
    class="user-widget"
    @mouseenter="showDropdown = true"
    @mouseleave="showDropdown = false"
  >
    <div class="user-info">
      <el-avatar
        :src="userImg"
        size="small"
        icon="el-icon-user-solid"
      ></el-avatar>
      <div class="user-name" :title="username">
        {{ username }}
      </div>
    </div>
    <transition name="dropdown">
      <div v-show="showDropdown" class="dropdown-menu">
<!--        <div class="dropdown-item" @click="logout">-->
<!--          <i class="el-icon-switch-button icon-logout"/>退出登录-->
<!--        </div>-->
<!--        <div class="dropdown-item" @click="goToProfile">-->
<!--          <i class="el-icon-user-solid icon-profile"/> 个人中心-->
<!--        </div>-->
        <div class="dropdown-divider"></div>
        <div class="dropdown-item" @click="goToHome">
          <i class="el-icon-s-home icon-home"/> 去往主页
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'UserWidget',
  props: {
    username: {
      type: String,
      default: '用户名',
    },
    avatar: {
      type: String,
      default: '',
    },
    userImg: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showDropdown: false,
    };
  },
  methods: {
    goToHome() {
      this.$emit('home');
      // 或者使用路由跳转
      // this.$router.push('/home');
    },
    goToProfile() {
      this.$emit('profile');
      // this.$router.push('/profile');
    },
    logout() {
      this.$emit('logout');
      // 实际退出逻辑，例如：
      // localStorage.removeItem('token');
      // this.$router.push('/login');
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .dropdown-menu{
    top: 22px !important;
    padding: 10px !important;
    width: 100px !important;
    z-index: 1000 !important;
  }
  .dropdown-divider {
    height: unset !important;
    background-color: #eee;
    margin: 0;
  }
  .dropdown-item{
    font-size: 13px !important;
  }
  .icon-home{
    font-size: 14px !important;
  }
}
.user-widget {
  position: relative;
  width: 130px;
  height: 40px;
  font-family: 'Arial', sans-serif;
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.user-info:hover {
  background-color: #eee;
}

.user-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: #4a90e2;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.user-name {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70px;
  margin-left: 10px;
}

.dropdown-menu {
  position: absolute;
  top: 45px;
  left: 0;
  width: 100%;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s ease;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-item {
  padding: 8px 10px;
  font-size: 13px;
  line-height: 16px;
  color: #333;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.dropdown-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.dropdown-item:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.dropdown-divider {
  height: 1px;
  background-color: #eee;
  margin: 0;
}

.icon-home,
.icon-profile,
.icon-logout {
  margin-right: 6px;
  font-size: 14px;
}
</style>
